<template>
  <div v-if="!isLast && (questionData.questionType !== 1 || isRelationRadioQuestion)" :class="['btn-wrapper', {'center': questionData.answerType == 1}]">
    <div v-if="questionData.answerType !== 1" class="skip-btn" @click="skip">跳过此题</div>
    <van-button :class="['next-btn', {'disabled': nextDisabled}]" @click="next">下一题</van-button>
  </div>
</template>

<script>
import { Toast } from 'vant';
import { getDisabled, skipToDefault, getTip } from '../helper';

export default {
  name: 'Btn',
  props: {
    value: {
      type: Number,
      default: 0
    },
    allQuestion: {
      type: Array,
      default: ()=>[]
    }
  },
  computed: {
    isRelationRadioQuestion() {
      const activeQues = this.allQuestion[this.value];
      if (activeQues?.questionType === 1) {
        const chosen = activeQues.memberAnswerList.filter(item => item.memberOptionSelected === 1);
        return (chosen?.[0]?.childAnswerList || [])?.length;
      }
      return false
    },
    isLast() {
      return this.value === this.allQuestion?.length - 1
    },
    questionData() {
      return this.allQuestion[this.value];
    },
    disabled() { // 关联题目是否合法
      return getDisabled(this.questionData);
    },
    nextDisabled() { // 下一题是否可点击
      let flag;
      if (this.questionData.answerType === 2) { // 选填
        if (this.questionData.questionType === 3) {
          flag = true;
          this.questionData?.memberAnswerList?.forEach(item => {
            if (item?.memberOptionContent || item?.memberAnswerPicList?.length) {
              flag = false;
            }
          });
        } else {
          const chosen = this.questionData.memberAnswerList.filter(item => item.memberOptionSelected === 1);
          flag = !chosen.length;
        }
      }
      return !(!flag && !this.disabled);
    }
  },
  data() {
    return {
    };
  },
  methods: {
    next() {
      if (this.disabled) {
        skipToDefault.value = {
          change: true,
          parent: this.questionData,
          detail: this.disabled
        };
        Toast(getTip(this.questionData));
        return;
      }
      if (this.nextDisabled) {
        Toast(getTip(this.questionData));
        return;
      }
      this.$emit('input', this.value + 1);
      this.$set(this.questionData, 'questionJoin', 1);
    },
    skip() {
      this.$sensors.track('survey_skip_click', {
        num: this.value + 1,
        memberQuestionnaireId: this.$route.query.memberQuestionnaireId
      });
      const memberAnswerList = this.questionData.memberAnswerList?.map(item => {
        return {
          ...item, 
          memberOptionContent: null,
          memberAnswerPicList: null,
          memberOptionSelected: 0
        }
      });
      this.$set(this.questionData, 'value', this.questionData.questionType === 2 ? [] : null);
      this.$set(this.questionData, 'questionJoin', 0);
      this.$set(this.questionData, 'memberAnswerList', memberAnswerList);
      this.$emit('input', this.value + 1);
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-wrapper {
  width: 100%;
  padding: 32px 32px 0 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  border-top: 1px solid #F0F0F0;
  .next-btn {
    width: 326px;
    height: 88px;
    background: linear-gradient(153deg, #FF7673 0%, #FF3D3D 100%);
    border-radius: 48px;
    text-align: center;
    color: #fff;
    font-weight: 500;
    font-size: 32px;
    border: none;
    &.disabled {
      background: #D4D4D4;
    }
  }
  .skip-btn {
    font-weight: 400;
    font-size: 24px;
    color: #979797;
    text-align: center;
  }
  &.center {
    justify-content: center;
  }
}
</style>
